<template>
  <div class="article-card">
    <div class="article-card__image-container">
      <oie-base-image
        :images="getAssetPath(image)"
        :alt-text="image"
        :image-width="418"
        :image-height="230"
        class="article-card__image"></oie-base-image>
    </div>

    <div class="article-card__content">
      <a href="#0" class="article-card__title">{{ title }}</a>

      <p class="article-card__text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true
    },
    date: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>
